/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  onClick?: any;
  className?: string;
};

const SvgComponent: FC<IProps> = ({ width = 19, height = 19, onClick, className }) => (
  <img
    width={width}
    height={height}
    onClick={onClick}
    src="/assets/icons/book-calendar.svg"
    alt="icons"
    className={className}
  />
);

export default SvgComponent;
